<template>
    <div style="height: 140px;">
        <div class="w-100 step-title v-flex" v-if="showTitle">
            <div
                class = "primary--text"
                style = "margin-bottom: 0; padding-top:  16px;"
            >
                {{ $t('contract.payment.title') }}
            </div>
            <v-checkbox
                v-model   = "contract.invoiceInAdvance"
                label     = "im Voraus"
                :ripple   = "false"
                :readonly = "readonly"
                style     = "margin-top: 11px"
                hide-details
            />
        </div>
        <v-row class="no-frame">
            <v-col class="no-frame pr-2 col-7">
            <v-select
                    v-if       = "frequency"
                    :items     = "frequency"
                    item-value = "id"
                    item-text  = "name"
                    label      = "Frequenz"
                    v-model    = "contract.invoiceFrequency"
                    class      = "mt-1"
                    @change    = "onRecalculate"
                    :readonly  = "readonly"
                    return-object
               />

            </v-col>
            <v-col class="no-frame pl-2">
                <v-row class="no-frame"  >
                    <v-col class="col-3 no-frame pr-2">
                        <v-text-field
                            label     = "Tag"
                            v-if="contract.invoiceFrequency && contract.invoiceFrequency.id !== 1 && contract.invoiceFrequency.id !== 0"
                            v-model   = "contract.invoiceDay"
                            :readonly = "readonly"
                            @input    = "onRecalculate"
                            type         = "number"
                            class        = "inputNumber"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                        />
                    </v-col>
                    <v-col class="col-9 no-frame pl-2">
                        <v-select
                            v-if="contract.invoiceFrequency && contract.invoiceFrequency.id !== 2 && contract.invoiceFrequency.id !== 1 && contract.invoiceFrequency.id !== 0"
                            :items     = "months"
                            item-value = "id"
                            item-text  = "name"
                            label      = "Monat"
                            v-model    = "contract.invoiceMonth"
                            :readonly  = "readonly"
                            @change    = "onRecalculate"
                            class      = "mt-1"
                        />
                    </v-col>
                </v-row>
                <!--
                <div v-if="!header">
                    <v-checkbox
                        v-model   = "contract.invoiceInAdvance"
                        label     = "im Voraus"
                        :ripple   = "false"
                        :readonly = "readonly"
                        style     = "margin-top: 11px"
                        hide-details
                    />
                </div>
                -->
            </v-col>
        </v-row>
        <v-row class="no-frame" v-if="contract.invoiceFrequency && contract.invoiceFrequency.id !== 1 && contract.invoiceFrequency.id !== 2 && contract.invoiceFrequency.id !== 0">
            <f-read-only-field
                class  = "w-100"
                label  = "Termine"
                :value = "deadline"
            />
        </v-row>
    </div>
</template>

<script>
import Msd from "@/modules/msd/common/service/Msd";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";

export default {
    name: "CContractPayment",
    components: {
        FReadOnlyField
    },

    props: {
        contract: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    invoiceInAdvance: null,
                    invoiceDay      : null,
                    invoiceMonth    : null,
                    invoiceFrequency: null
                }
            },
        },

        frequenies: {
            required: false,
            type    : Array,
            default : function () {
                return null;
            }
        },

        showTitle: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    data: () => ({
        deadline: null,
    }),

    mounted() {
        this.onRecalculate();
    },

    watch: {
        contract: {
            deep: true,
            handler: function () {
                this.onRecalculate();
            }
        }
    },

    computed: {
        site () {
            return this.$store.getters.site;
        },

        frequency () {
            if (this.frequenies) {
                return this.$store.getters.frequency.filter (f => {
                     return this.frequenies.includes(f.id);
                });
            }

            return this.$store.getters.frequency;
        },

        months () {
            return this.$store.getters.month;
        },
    },

    methods: {
        onRecalculate () {
            if (!this.contract.invoiceFrequency || this.contract.invoiceFrequency.id < 3) {
                this.deadline = null;
            } else {
                this.deadline = Msd.contract.mnt.deadlines(this.contract, this.months);
            }
        }
    }
}
</script>

<style scoped>

</style>